module.exports = new __parcel__URL__("RestrictedContentIcon-Dark.bc90ae31.svg").toString();